import {StrapiBaseFields} from "../Base/Base.types";

export interface IUser {
    activated: number,
    active:boolean,
    blocked: boolean | null,
    email: string,
    first_name: string,
    id: number,
    last_name: string,
    role: IUserRole,
    user_group: number,
    username: string,
    picture?: string
    account_status: EAccountStatus,
    company: ICompany,
    alternate_emails: string,
    allow_alert_emails?: boolean,
}

export interface ICompany extends StrapiBaseFields {
    id: number,
    duns_number: string,
    name: string,
    states_of_business: string,
    keywords:string,
    psc_codes:string,
    naics_codes:string,
}

export enum EAccountStatus {
    INVITATION_SENT = 'invitation_sent',
    INVITATION_CONSUMED = 'invitation_consumed',
    VALIDATED = 'validated',
}

export interface ISignupValues {
    username?: string,
    first_name: string,
    last_name: string,
    email: string,
    password: string,
}

export interface IUserRole {
    description: string,
    id: number,
    name: string,
    type: string,
}

export interface ILoginValues {
    username: string,
    password: string,
}

export interface ILoginResponse {
    jwt: string,
    user: IUser,
}

export interface ISignupResponse {
    jwt: string,
    user: IUser,
}

export interface IAcceptInvitationRequestBody {
    duns_number?: string,
    alternate_emails?: string,
    company_name?: string,
    email?: string,
    states_of_business?: string,
    company_id: number,
    psc_codes?: string,
    naics_codes?: string,
}